module.exports = __webpack_public_path__ + "static/logo-construction-schematics-white-dba0d784af14a645aa1f31114a6e4680.png";